import React, { FC, forwardRef, useImperativeHandle, useRef } from 'react'
import { usePutDocumentSettingsMutation } from '@features/knowledgeBase'
import { KBDocument } from '@feedyou/utils'

import { FeedbotRjsfForm, HiddenSubmitButton } from '../../../design-system/FeedbotRjsfForm'
import { ModalFooterButton } from '../../styles'
import { useOpenBotId } from '../../../../store/app'
import { useSettingsPopupState } from '../../hooks'

export type KnDocumentSettingsHandle = {
  save: () => void
}

type Props = {
  modelId: string
  document: KBDocument<'raw'>
  onSubmit: () => void
}

export const KBDocumentSettings = forwardRef<KnDocumentSettingsHandle, Props>(
  ({ document, modelId, onSubmit }, ref) => {
    const botId = useOpenBotId()
    const submitButtonRef = useRef<HTMLButtonElement>(null)

    const initialFormData = document.settings.document || { status: '', splitter: {} }

    const { formData, onFormDataChange } = useSettingsPopupState(
      () => initialFormData,
      [document.settings.document]
    ) as any

    const [putDocumentSettings] = usePutDocumentSettingsMutation()

    useImperativeHandle(ref, () => ({
      save: () => submitButtonRef.current?.click()
    }))

    return (
      <>
        <FeedbotRjsfForm
          formData={formData}
          onChange={({ formData }) => onFormDataChange(formData)}
          onSubmit={({ formData }) => {
            console.log('SUBMITTING XD', formData)
            // @ts-ignore
            putDocumentSettings({ botId, modelId, documentId: document.id, settings: formData })
            onSubmit()
          }}
          schema={schema as any}
          uiSchema={uiSchema}
        >
          <HiddenSubmitButton ref={submitButtonRef} />
        </FeedbotRjsfForm>
      </>
    )
  }
)

export const KBDocumentSettingsFooter: FC<{ submit(): void; close(): void }> = ({
  submit,
  close
}) => {
  return (
    <>
      <ModalFooterButton label="Close" className="e2e-close-bot-modal-button" onClick={close} />
      <ModalFooterButton
        emphasis="primary"
        label="Save"
        className="e2e-modal-success-button"
        onClick={submit}
      />
    </>
  )
}

const schema = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      title: 'Status',
      default: '',
      oneOf: [
        { title: 'Inherit', const: '' },
        { title: 'Used', const: 'used' },
        { title: 'Ignored', const: 'ignored' }
      ]
    }
  },
  allOf: [
    {
      if: { properties: { status: { const: 'ignored' } } },
      then: {},
      else: {
        properties: {
          priority: { type: 'number', title: 'Priority', minimum: -10, maximum: 10 },
          splitter: {
            type: 'object',
            title: 'Splitter',
            properties: {
              maxChunkLength: { type: 'number', title: 'Max chunk length' },
              chunkOverlap: { type: 'string', title: 'Chunk overlap' }
            }
          },
          tags: { type: 'array', title: 'Tags', items: { type: 'string', title: 'Tag' } }
        }
      }
    }
  ],
  required: []
}

const uiSchema = {
  ignored: {
    'ui:widget': 'radio'
  },
  priority: { 'ui:widget': 'range' }
}
